import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import candidateService from "services/CandidateService";
import { message } from "antd";

export const initialState = {
  loadingCandidates: false,
  LoadingCandidateById: false,
  candidates: [],
  totalRecord: 0,
  cv: null,
  candidateDetailById: [],
  certificates: [],
  loadingLanguages: false,
  loadingHistory: false,
  languages: [],
  loadingCertificate: false,
  nationalities: [],
  loadingNationalities: false,
  loadingReligions: false,
  religions: [],
  loadingMaritalStatus: false,
  maritalStatus: [],
  languageLevels: [],
  loadingLanguageLevel: false,
  loadingBlood: false,
  blood: [],
  loadingStatusCandidate: false,
  statusCandidate: [],
  loadingGender: false,
  gender: [],
  degrees: [],
  loadingDegrees: false,
  candidateByagency: [],
  loadingCandidateByagency: false,
  applicationsHistory: [],
  offersHistory: [],
  interviewsHistory: [],
  loadingBulkUploadCandidate: false,
};

export const GetCandidateSSR = createAsyncThunk(
  "/Candidate/GetAllSSR",
  async (data, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetCandidateSSSR(data);
      if (response.success === false) {
        return rejectWithValue(response.message);
      } else {
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const GetCandidateById = createAsyncThunk(
  "/Candidate/GetById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetCandidateById({ id });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const GetSimpleCanidate = createAsyncThunk(
  "/Candidate/GetSimpleCanidate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetSimpleCanidate(data);

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetMaritalStatus = createAsyncThunk(
  "/Candidate/GetMaritalStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetMaritalStatus();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetLanguages = createAsyncThunk(
  "/Candidate/GetLanguages",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetLanguages();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetLanguageLevels = createAsyncThunk(
  "/Candidate/GetLanguageLevels",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetLanguageLevels();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetNationalities = createAsyncThunk(
  "/Candidate/GetNationalities",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetNationalities();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetReligions = createAsyncThunk(
  "/Candidate/GetReligions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetReligions();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetBloodTypes = createAsyncThunk(
  "/Candidate/GetBloodTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetBloodTypes();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetStatus = createAsyncThunk(
  "/Candidate/GetStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetStatus();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetGender = createAsyncThunk(
  "/Candidate/GetGender",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetGender();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetDegreeTypes = createAsyncThunk(
  "/Candidate/GetDegreeTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await candidateService.GetDegreeTypes();
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const CandiateUpdate = createAsyncThunk(
  "/Candidate/Update",
  async (data, { rejectWithValue }) => {
    try {
      const response = await candidateService.Update(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const CreateAgencyCandidate = createAsyncThunk(
  "/Candidate/CreateAgencyCandidate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await candidateService.CreateAgencyCandidate(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return rejectWithValue(response.message);
      } else {
        message.success({
          content: ` ${response.message}`,
        });

        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const SetActive = createAsyncThunk(
  "/Candidate/SetIsActive",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await candidateService.SetActive({ id, status });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const CandidateHistory = createAsyncThunk(
  "/Candidate/CandidateHistory",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await candidateService.CandidateHistory({ id });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
      }
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const DownloadExcelFile = createAsyncThunk(
  "/Candidate/DownloadExcelFile",
  async ({}, { rejectWithValue }) => {
    try {
      const response = await candidateService.DownloadSampleExcelFile();

      window.open(response.result, "_blank");
      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const BulkUploadCandidate = createAsyncThunk(
  "/Candidate/BulkInserCandidate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await candidateService.BulkUploadCandidate(data);
      if (response.success) {
        message.success({
          content: ` ${response.message}`,
        });
      } else {
        message.error({
          content: ` ${response.message}`,
        });
      }

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const candidateSlice = createSlice({
  name: "candidate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetCandidateSSR.pending, (state) => {
        state.loadingCandidates = true;
      })

      .addCase(GetCandidateSSR.fulfilled, (state, action) => {
        state.loadingCandidates = false;
        state.candidates = action.payload.data;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(GetCandidateSSR.rejected, (state, action) => {
        state.candidates = [];
        state.loadingCandidates = false;
      })
      .addCase(GetCandidateById.pending, (state) => {
        state.LoadingCandidateById = true;
      })
      .addCase(GetCandidateById.fulfilled, (state, action) => {
        state.loadingCertificate = false;
        state.candidateDetailById = action.payload;
        state.LoadingCandidateById = false;
      })
      .addCase(GetCandidateById.rejected, (state, action) => {
        state.candidates = [];
        state.certificates = [];
        state.candidateDetailById = [];
        state.cv = null;
        state.LoadingCandidateById = false;
      })
      .addCase(GetSimpleCanidate.pending, (state) => {
        state.loadingCandidateByagency = true;
      })
      .addCase(GetSimpleCanidate.fulfilled, (state, action) => {
        state.loadingCandidateByagency = false;
        state.candidateByagency = action.payload;
      })
      .addCase(GetSimpleCanidate.rejected, (state, action) => {
        state.loadingCandidateByagency = false;
        state.candidateByagency = [];
      })
      .addCase(GetLanguages.pending, (state) => {
        state.loadingLanguages = true;
      })
      .addCase(GetLanguages.fulfilled, (state, action) => {
        state.loadingLanguages = false;

        state.languages = action.payload;
      })
      .addCase(GetLanguages.rejected, (state, action) => {
        state.loadingLanguages = false;
        state.languages = [];
      })
      .addCase(GetNationalities.pending, (state) => {
        state.loadingNationalities = true;
      })
      .addCase(GetNationalities.fulfilled, (state, action) => {
        state.loadingNationalities = false;
        state.nationalities = action.payload;
      })
      .addCase(GetNationalities.rejected, (state, action) => {
        state.loadingNationalities = false;
        state.nationalities = [];
      })
      .addCase(GetReligions.pending, (state) => {
        state.loadingReligions = true;
      })
      .addCase(GetReligions.fulfilled, (state, action) => {
        state.loadingReligions = false;
        state.religions = action.payload;
      })
      .addCase(GetReligions.rejected, (state, action) => {
        state.loadingReligions = false;
        state.religions = [];
      })
      .addCase(GetMaritalStatus.pending, (state) => {
        state.loadingMaritalStatus = true;
      })
      .addCase(GetMaritalStatus.fulfilled, (state, action) => {
        state.loadingMaritalStatus = false;
        state.maritalStatus = action.payload;
      })
      .addCase(GetMaritalStatus.rejected, (state, action) => {
        state.loadingMaritalStatus = false;
        state.maritalStatus = [];
      })
      .addCase(GetLanguageLevels.pending, (state) => {
        state.loadingLanguageLevel = true;
      })
      .addCase(GetLanguageLevels.fulfilled, (state, action) => {
        state.loadingLanguageLevel = false;
        state.languageLevels = action.payload;
      })
      .addCase(GetLanguageLevels.rejected, (state, action) => {
        state.loadingLanguageLevel = false;
        state.languageLevels = [];
      })
      .addCase(GetBloodTypes.pending, (state) => {
        state.loadingBlood = true;
      })
      .addCase(GetBloodTypes.fulfilled, (state, action) => {
        state.loadingBlood = false;
        state.blood = action.payload;
      })
      .addCase(GetBloodTypes.rejected, (state, action) => {
        state.loadingBlood = false;
        state.blood = [];
      })
      .addCase(GetStatus.pending, (state) => {
        state.loadingStatusCandidate = true;
      })
      .addCase(GetStatus.fulfilled, (state, action) => {
        state.loadingStatusCandidate = false;
        state.statusCandidate = action.payload;
      })
      .addCase(GetStatus.rejected, (state, action) => {
        state.loadingStatusCandidate = false;
        state.statusCandidate = [];
      })
      .addCase(GetGender.pending, (state) => {
        state.loadingGender = true;
      })
      .addCase(GetGender.fulfilled, (state, action) => {
        state.loadingGender = false;
        state.gender = action.payload;
      })
      .addCase(GetGender.rejected, (state, action) => {
        state.loadingGender = false;
        state.gender = [];
      })
      .addCase(GetDegreeTypes.pending, (state) => {
        state.loadingDegrees = true;
      })
      .addCase(GetDegreeTypes.fulfilled, (state, action) => {
        state.loadingDegrees = false;
        state.degrees = action.payload;
      })
      .addCase(GetDegreeTypes.rejected, (state, action) => {
        state.loadingDegrees = false;
        state.degrees = [];
      })
      .addCase(CandidateHistory.pending, (state) => {
        state.loadingHistory = true;
      })
      .addCase(CandidateHistory.fulfilled, (state, action) => {
        state.loadingHistory = false;

        state.applicationsHistory = action.payload?.applications;
      })
      .addCase(CandidateHistory.rejected, (state, action) => {
        state.loadingHistory = false;
      })
      .addCase(BulkUploadCandidate.pending, (state) => {
        state.loadingBulkUploadCandidate = true;
      })
      .addCase(BulkUploadCandidate.fulfilled, (state, action) => {
        state.loadingBulkUploadCandidate = false;
      })
      .addCase(BulkUploadCandidate.rejected, (state, action) => {
        state.loadingBulkUploadCandidate = false;
      });
  },
});

export const {} = candidateSlice.actions;

export default candidateSlice.reducer;
